<template>
    <div class="approve-level-page">
        <el-tabs v-model="activeTab" type="card" @tab-click="onTabClick" class="level-tabs">
            <el-tab-pane label="Tiến độ level Teamlead" name="teamlead">
                <TeamleadProgressTab v-if="activeTab==='teamlead'" />
            </el-tab-pane>

            <el-tab-pane label="Tiến độ level Nhân viên" name="employee">
                <EmployeeProgressTab v-if="activeTab==='employee'" />
            </el-tab-pane>

            <el-tab-pane label="Duyệt level chuyên môn" name="domain">
                <DomainReviewTab v-if="activeTab==='domain'" />
            </el-tab-pane>

            <el-tab-pane label="Duyệt level quản trị" name="admin">
                <AdminReviewTab v-if="activeTab==='admin'" />
            </el-tab-pane>
        </el-tabs>
    </div>

</template>

<script>
export default {
    name: 'ApproveTeamLevel',
    components: {
        TeamleadProgressTab: () => import('./components/TeamleadProgressTab.vue'),
        EmployeeProgressTab: () => import('./components/EmployeeProgressTab.vue'),
        DomainReviewTab: () => import('./components/DomainReviewTab.vue'),
        AdminReviewTab: () => import('./components/AdminReviewTab.vue'),
    },
    data() {
        return {
            activeTab: (this.$route && this.$route.query && this.$route.query.tab) ? this.$route.query.tab : 'teamlead',
        };
    },
    watch: {
        '$route.query.tab'(value) {
            if (value && value !== this.activeTab) {
                this.activeTab = value;
            }
        },
    },
    methods: {
        onTabClick(tab) {
            if (this.$route && this.$router) {
                // Clear all previous query params and keep only current tab
                this.$router.replace({ path: this.$route.path, query: { tab: tab.name } });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.level-tabs {
  /deep/ .el-tabs__item {
    border: 0 !important;
    color: #4d1eab;
    line-height: 38px;
    height: 38px;
    border-radius: 2px;
    transition: all .2s ease;
  }

  /deep/ .el-tabs__item:not(.is-active):hover {
    background: #f4ecff;
    color: #4d1eab;
  }

  /deep/ .el-tabs__item.is-active {
    background: #4d1eab;
    color: #fff;
    box-shadow: 0 4px 10px rgba(111,45,189,.25);
  }
}
</style>




